/* eslint-disable */
import settings from "../../../configs/settings";
import { Autocomplete, Box, Paper, TextField, Typography, Fab, Tooltip } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import PriceChangeOutlinedIcon from "@mui/icons-material/PriceChangeOutlined";
import { isNumeric } from "../../../project/utils/utils";
import CobranzaContext from "../../../project/contexts/CobranzaContext";
import { getCacheData } from "../../services/CacheService";
//
// ################################################################################
//
const CobroBilletera = () => {
  const [valueACBilletera, setValueACBilletera] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACBilletera, setInputValueACBilletera] = useState("");

  const {
    setMessage,
    setShowMessage,
    handleChangeMedioDeCobro,
    limpiaMedioDeCobro,
    medioDeCobroAction,
    medioDeCobro,
    setMedioDeCobro,
    agregaMedioDeCobro,
    setExpandedAccordionMediosDeCobro,
    restoACobrar,
  } = useContext(CobranzaContext);

  const { idBilletera, descripcionBilletera, importe } = medioDeCobro;
  const [billeteras, setBilleteras] = useState([]);
  const _importeAnterior = medioDeCobro.importe;
  //
  // ################################################################################
  //
  useEffect(() => {
    loadBilleteras();
    setValueACBilletera({
      id: idBilletera,
      descripcion: descripcionBilletera,
    });
  }, []);
  //
  // ################################################################################
  //
  const loadBilleteras = async () => {
    const response = await getCacheData('billetera');
    if (response.ok) {
      setBilleteras(response.data.data);
    } else {
      setBilleteras([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    setMedioDeCobro({
      ...medioDeCobro,
      idBilletera: valueACBilletera.id,
      descripcionBilletera: valueACBilletera.descripcion,
    });
  }, [valueACBilletera]);

  //
  // ################################################################################
  //
  const cancelaCobro = () => {
    limpiaMedioDeCobro();
    setExpandedAccordionMediosDeCobro(false);
  };
  //
  // ################################################################################
  //
  const actualizaCobro = () => {
    // valido los datos del cobro

    if (inputValueACBilletera === "") {
      setMessage({
        severity: "error",
        messageText: "Debes seleccionar una Billetera",
      });
      setShowMessage(true);
      return;
    }

    if (typeof importe === "string") {
      if (!isNumeric(importe)) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar un importe mayor a 0",
        });
        setShowMessage(true);
        return;
      }
    }

    if (+importe <= 0) {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar un importe mayor a 0",
      });
      setShowMessage(true);
      return;
    }

    if (
      +importe >
      (medioDeCobroAction.cu === "new" ? restoACobrar : restoACobrar + _importeAnterior)
    ) {
      setMessage({
        severity: "error",
        messageText: "El importe cobrado debe ser menor o igual al resto a cobrar",
      });
      setShowMessage(true);
      return;
    }

    // si no hay errores agrego el medio de cobro a la tabla de medios de cobro

    agregaMedioDeCobro("billetera-virtual");
  };
  //
  // ################################################################################
  //
  const asignaRestoACobrar = () => {
    setMedioDeCobro({
      ...medioDeCobro,
      importe: restoACobrar,
    });
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={2} sx={{ mt: 1, p: 2 }}>
        <Typography component={"span"} variant={"body1"}>
          Billetera
        </Typography>

        <Box sx={{ mt: 1 }}>
          <Autocomplete
            id="billeteraOptions"
            size="small"
            value={valueACBilletera}
            onChange={(event, newValue) => {
              setValueACBilletera(newValue);
            }}
            inputValue={inputValueACBilletera}
            onInputChange={(event, newInputValue) => {
              setInputValueACBilletera(newInputValue);
            }}
            options={billeteras}
            renderInput={(params) => <TextField {...params} label="Billetera" />}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            getOptionLabel={(option) => option.descripcion ?? option}
            disableClearable={true}
          />
        </Box>
        <Box sx={{ mt: 1 }}>
          <TextField
            sx={{ width: "50%" }}
            id="importe"
            label="Importe"
            variant="outlined"
            size="small"
            name="importe"
            value={importe.toLocaleString(
              settings.numericLocales.language,
              settings.numericLocales.options
            )}
            onChange={handleChangeMedioDeCobro}
            inputProps={{
              autoComplete: "off",
              style: { textAlign: "right" },
            }}
          />
          <Tooltip title="asignar el resto a cobrar">
            <Fab
              sx={{ ml: 1, mr: 1 }}
              color="secondary"
              aria-label="add"
              size="small"
              onClick={asignaRestoACobrar}
            >
              <PriceChangeOutlinedIcon />
            </Fab>
          </Tooltip>
        </Box>

        <Box sx={{ p: 1 }}>
          <Tooltip title="agragar cobranza">
            <Fab
              sx={{ mr: 1 }}
              color="primary"
              aria-label="add"
              size="small"
              onClick={actualizaCobro}
            >
              <CheckOutlinedIcon />
            </Fab>
          </Tooltip>

          <Tooltip title="cancelar">
            <Fab
              sx={{ mr: 1 }}
              color="outlined"
              aria-label="add"
              size="small"
              onClick={cancelaCobro}
            >
              <CloseOutlinedIcon />
            </Fab>
          </Tooltip>
        </Box>
      </Paper>
    </>
  );
};

export default CobroBilletera;
